import Spinners from "components/Common/Spinner"
import FullPageLoader from "components/fullPageLoader"
import { sweetAlertClasses } from "helpers/common"
import React, { useEffect, useRef, useState } from "react"
import toast from "react-hot-toast"
import { useDispatch, useSelector } from "react-redux"

import { Row, Col } from "reactstrap"
import {
  useGenerateTemplateTokenMutation,
  useLazyGetStatusOfOldDigioRequestQuery,
  useUpdateDiogioRequestStatusMutation,
} from "store/api/kyc/kyc"
import Swal from "sweetalert2"
import KYCPrevButton from "./kycPrevButton"
import digioLogo from "../../assets/images/digioLogo.png"

const IDVerification = ({ kycData }) => {
  const { user, userType } = useSelector((state) => state.user)
  const [isLoading, setIsLoading] = useState(false)
  const [requestData, setRequestData] = useState(null)
  const dispatch = useDispatch()
  const [loader, setLoader] = useState(false)
  const [getToken, { isLoading: isFetching }] =
    useGenerateTemplateTokenMutation()
  const [getRequestStatus] = useLazyGetStatusOfOldDigioRequestQuery()
  const [updateDiogioRequestTrigger] = useUpdateDiogioRequestStatusMutation()
  const intervalRef = useRef(null)
  const template_name = "DIGILOCKER_AADHAAR_PAN_ICD"

  useEffect(() => {
    if (user && user.entity_type === "INDIVIDUAL" && kycData) {
      if (
        kycData?.investorsPAN &&
        kycData.pan_no !== kycData?.investorsPAN?.pan
      ) {
        Swal.fire({
          title: "Error!",
          html: ` <p>The PAN fetched from DigiLocker doesn't match the PAN used at the time of registration. Please ensure you're accessing the correct DigiLocker account and try again.</p>`,
          icon: "error",
          confirmButtonColor: "#BD0000",
          confirmButtonText: "Try again",
          customClass: { ...sweetAlertClasses },
        })
      }
    }
  }, [user, kycData])

  useEffect(() => {
    onGetRequestStatus()

    return () => {
      if (intervalRef) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  const onGetRequestStatus = async () => {
    try {
      const { data } = await getRequestStatus({ template_name }).unwrap()
      setRequestData(data)
      if (data.status === "kyc.request.approved" && intervalRef?.current) {
        window.location.reload()
        clearInterval(intervalRef.current)
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (kycData && requestData) {
      if (
        kycData.status === "KYC_PENDING" &&
        requestData.status === "kyc.request.completed" &&
        requestData.kyc_status === "KYC_PENDING"
      ) {
        setLoader(true)
        const id = setInterval(() => {
          onGetRequestStatus()
        }, 5000)
        intervalRef.current = id
      }
      if (
        kycData.status === "QUERY_RAISED" &&
        requestData.status === "kyc.request.completed" &&
        requestData.kyc_status === "QUERY_RAISED"
      ) {
        setLoader(true)
        const id = setInterval(() => {
          onGetRequestStatus()
        }, 5000)
        intervalRef.current = id
      }
    }
  }, [requestData, kycData])

  const startKYC = async () => {
    try {
      setIsLoading(true)
      const { data, success, message } = await getToken({
        template_name,
      }).unwrap()

      if (success) {
        if (window.Digio) {
          const options = {
            environment: "production", //<sandbox, production>
            callback: function (response) {
              if (response.hasOwnProperty("error_code")) {
                console.log("Error occurred in process", response)
              } else {
                updateDiogioRequestTrigger({
                  id: response.digio_doc_id,
                }).unwrap()
                setLoader(true)
                setTimeout(() => {
                  setLoader(false)
                  window.location.reload()
                }, 10000)
              }
            },
            event_listener: function (event) {
              console.log("event_listener", event)
            },
            is_iframe: true,
            logo: digioLogo,
            theme: {
              primaryColor: "#000000",
              secondaryColor: "#000000",
            },
          }
          if (data?.documentId) {
            const digio = new window.Digio(options)
            digio.init()

            const documentId = data.documentId
            const identifier = data.identifier
            const tokenId = data.tokenId

            digio.submit(documentId, identifier, tokenId)
          }
          // If using token approach:
        } else {
          console.error("Digio SDK not loaded")
        }
      } else {
        toast.error(message, { id: "toastMessage" })
      }
    } catch (error) {
      toast.error("Something went wrong, Please try again after sometime", {
        id: "toastMessage",
      })
    } finally {
      setIsLoading(false)
    }
  }

  if (loader) return <FullPageLoader />

  return (
    <>
      <Row>
        <div className="id-verification-wrapper">
          <h5 className="heading">Proof of Identification</h5>
          {/* <p>
            You will be redirected to the DigiLocker website to fetch and verify
            your KYC details.
          </p> */}
          <div className="id-verification-details">
            <div className="id-verification-card">
              <h5>Step 1: Access Your DigiLocker Account </h5>
              <p>- Log in using Aadhaar OTP-based authentication</p>
              <p>- Enter your DigiLocker Security PIN when prompted</p>
            </div>
            <div className="id-verification-card">
              <h4
                style={{
                  fontSize: "18px",
                }}
              >
                If you do not have a DigiLocker account:
              </h4>
              <p>- Select "Sign Up" or "Register" to create a new account</p>
              <p>- Complete the Aadhaar authentication process</p>
              <p>- Set a Security PIN for your account</p>
              <p>- Enter your PAN details to enable document retrieval</p>
            </div>
            <div className="id-verification-card">
              <h5>Step 2: Retrieve and Share KYC Documents</h5>
              <p>
                - Navigate and select the required KYC documents (Aadhaar Card
                and PAN Card)
              </p>
              <p>
                - Review and accept the terms and conditions to authorize
                sharing of the selected records
              </p>
            </div>
          </div>
          <Col sm={12}>
            <Row className="mt-4">
              <KYCPrevButton
                kycData={kycData}
                disabled={isLoading || isFetching}
                ButtonHtml={
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={() => startKYC()}
                  >
                    {isLoading || isFetching ? <Spinners /> : "Start KYC"}
                  </button>
                }
              />
            </Row>
          </Col>
          <div className="mt-2">
            <span
              className="text-muted"
              style={{
                fontStyle: "italic",
              }}
            >
              Note: You will be redirected to the DigiLocker website to fetch
              and verify your KYC details.
            </span>
          </div>
        </div>
      </Row>
    </>
  )
}

export default IDVerification
